import customAxios from "../../customAxios";
import { ISignUp } from "../../../types/common.interface";
import { SIGNUP } from "../../routes";

async function signUp(props: ISignUp) {
  var thisUrl = SIGNUP;

  let body: any = {
    role: props.role,
    firstName: props.firstName,
    lastName: props.lastName,
    phoneNumber: props.phoneNumber,
    userName: props.userName,
    password: props.password,
  };

  // !! ---------------------------------------------------------------------------------------------------------------------
  // !! =====================================================================================================================
  // !!                                            Try Catch For SuperAgent
  // !! =====================================================================================================================
  // !! ---------------------------------------------------------------------------------------------------------------------

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ GET_ALL_COMPANY: error });
  }
}

export default signUp;
